import ApiService, { MsgResponse } from "../../services/ApiService"
import { AxiosResponse } from "axios"
import { UpdateTestCodesDTO } from "./TestCodeManagement"
import { ApiLogin } from "../../types/types"

export default class TestCodeManagementApiService {
    static searchTestCodesContaining = (usernameSearchString: string) => {
        const url = `${ApiService.API_URL}logins/test-code-search?usernameSearchString=${encodeURIComponent(usernameSearchString)}`
        return ApiService.get(url).then((response: AxiosResponse<ApiLogin[]>) => response.data)
    }

    static updateTestCodeHandwrittenStatus = (data: UpdateTestCodesDTO) => {
        const url = `${ApiService.API_URL}admin-tools/all-handwritten-codes/update`
        return ApiService.post(url, data).then((response: AxiosResponse<MsgResponse>) => response.data)
    }

    static updateAllowTest = (loginId: number, allowTest: boolean) => {
        const url = `${ApiService.API_URL}logins/${encodeURIComponent(loginId)}/allow-test`
        return ApiService.post(url, { allowTest }).then((response: AxiosResponse<boolean>) => response.data)
    }

    static updateRostered = (loginId: number, rostered: boolean) => {
        const url = `${ApiService.API_URL}logins/${encodeURIComponent(loginId)}/update-rostered`
        return ApiService.post(url, { rostered }).then((response: AxiosResponse<boolean>) => response.data)
    }

    static updateProctorType = (loginId: number, proctorType: string) => {
        const url = `${ApiService.API_URL}logins/${encodeURIComponent(loginId)}/proctor-type`
        return ApiService.post(url, { proctorType }).then((response: AxiosResponse<boolean>) => response.data)
    }
}
